import { render } from "./SectionComboardComment.vue?vue&type=template&id=71348030"
import script from "./SectionComboardComment.vue?vue&type=script&lang=js"
export * from "./SectionComboardComment.vue?vue&type=script&lang=js"

import "./SectionComboardComment.vue?vue&type=style&index=0&id=71348030&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__